import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import moment from 'moment';
import { NgApexchartsModule } from 'ng-apexcharts';
import { DashboardService } from 'src/app/modules/home/dashboard-widgets/services/dashboard.service';
import { LoaderService } from 'src/app/services/loader.service';
import { BillingPeriodData, InvoicePaymentsResponse, PaymentData } from 'src/app/modules/home/dashboard-widgets/models/dashboard.model';
import { LoaderComponent } from '../../loader/loader.component';
import { TranslationModule } from 'src/app/modules/i18n';
import { Subscription } from 'rxjs';
import { AppSettingsService } from 'src/app/services/app-settings.service';
import { CommonModule } from '@angular/common';
import { C3CommonModule } from 'src/app/shared/c3-common-module/c3-common-module.module';

@Component({
  selector: 'app-accounts-receivable',
  standalone: true,
  imports: [
    NgApexchartsModule,
    LoaderComponent,
    TranslationModule,
    CommonModule,
    C3CommonModule,
    
],
  templateUrl: './accounts-receivable.component.html',
  styleUrl: './accounts-receivable.component.scss'
})
export class AccountsReceivableComponent implements OnInit, OnDestroy {
  billingPeriodsData: BillingPeriodData;
  paymentsData: PaymentData[] = [];
  chartOptions: any; 
  startBillingDate: string; 
  endBillingDate: string; 
  billGenerationDate: string; 
  isLoading: boolean = false;   
  globalDateFormat: any = '';
  private subscription: Subscription;
  totalAmount:number
  constructor(
    private dashboardWidgetsService: DashboardService,
    private cdref: ChangeDetectorRef,
    private _appService: AppSettingsService,
    private loaderService: LoaderService
  ) { }

  // Lifecycle hook to initialize the component
  ngOnInit(): void {
    this.loaderService.startLoading(); 
    this.isLoading = true;
    this.globalDateFormat = this._appService.$rootScope.dateFormat;
    this.dashboardWidgetsService.getBillingPeriods().subscribe((billingPeriods:any)=>{
       this.billingPeriodsData = (billingPeriods.Data[billingPeriods.Data.length - 1]);
       const billingId = billingPeriods.Data[billingPeriods.Data.length - 1].BillingPeriodId;
       this.startBillingDate = moment(this.billingPeriodsData?.BillingStartDate).format(this.globalDateFormat); 
       this.endBillingDate = moment(this.billingPeriodsData?.BillingEndDate).format(this.globalDateFormat); 
       this.billGenerationDate = moment(this.billingPeriodsData?.BillGenerationDate).format(this.globalDateFormat); 
       this.getInvoicePayments(billingId);
    })

  }

  // Method to fetch invoice payments data
  getInvoicePayments(billingId:number): void {
    this.subscription= this.dashboardWidgetsService.getInvoicePayments(billingId).subscribe(
      (data: Partial<InvoicePaymentsResponse>) => {
        this.paymentsData = data?.Data || []; 
        this.calculateChartData(); 
        this.loaderService.stopLoading(); 
        this.isLoading = false; 
      }
    );
  }

  // Method to calculate chart data
  calculateChartData(): void {
    const totalAmount = this.paymentsData.reduce((sum, item) => sum + item.TotalAmount, 0); 
    this.totalAmount = totalAmount;
    const Dataseries = this.paymentsData.map(item => (item.TotalAmount / totalAmount) * 100); 
    const labels = ['Received', 'Not Received', 'In Progress', 'Failed']; 
    this.initChart(Dataseries, labels); 
    this.cdref.detectChanges(); 
  }

  // Method to initialize chart options
  initChart(Dataseries: number[], labels: string[]): void {
    const absoluteDataseries = Dataseries.map(value => Math.abs(value));
    this.chartOptions = {
      colors:["#20c570", "#880085", "#d2e600", "#ff2400", "#b2d767", "#C0C0C0"],
      series: absoluteDataseries,
      chart: {
        height: 460,
        type: "donut",
      },
      fill: {
        type: 'gradient',
      },
      labels: labels,
      dataLabels: {
        enabled: false
      },
      legend: {
        position: 'bottom',
        //width: 100,
        formatter: function(seriesName, opts) {
          return ((seriesName?.length>12) ? seriesName?.toString()?.slice(0,12)+'...' : seriesName)
        }
      },
      responsive: [
        {
          breakpoint: 1500,
          options: {
            chart: {
              height: 280
            },
          }
        },
        {
          breakpoint: 1360,
          options: {
            chart: {
              height: 259
            },
          }
        },
        {
          breakpoint: 1050,
          options: {
            chart: {
              height: 250
            },
            legend: {
              show: false
            }
          }
        },
        {
          breakpoint: 767,
          options: {
            chart: {
              height: 250
            },
            legend: {
              show: false
            }
          }
        },
        {
          breakpoint: 320,
          options: {
            chart: {
              height: 170
            },
          }
        }
      ],
      tooltip: {
        y: {
          formatter: (value: number) => {
            return `${value.toFixed(2)}%`; // Format tooltip values as percentages
          }
        }
      },
      yaxis: {
        labels: {
          style: {
            colors: "#99A1B7",
            fontSize: "12px",
            cssClass: "apexcharts-yaxis-label"
          }
        }
      },
      xaxis: {
        labels: {
          style: {
            colors: "#99A1B7",
            fontSize: "12px",
            cssClass: "apexcharts-yaxis-label"
          }
        }
      }
    };
  }
ngOnDestroy(): void {
  this.subscription?.unsubscribe();
}
}
